import React from 'react';
import { Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';

const Overlay = ({ message, OverlaySx = {} }) => (
    <GridOverlay sx={OverlaySx}>
        <Typography variant="h6">{message}</Typography>
    </GridOverlay>
);

export default Overlay;
